module.exports = __webpack_public_path__ + "img/icon-report-creating.062786ec.svg";